var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"no"},[_c('img',{attrs:{"src":_vm.$store.state.imgHeadUrl + 'noContent.png',"alt":""}}),_c('div',{staticClass:"no-word"},[_vm._v("当前内容已下架，请查看其他内容")])])
}
var staticRenderFns = []

export { render, staticRenderFns }